import React from 'react';
import { block } from '../../utils/cn';
const b = block('text-input');
export const AdditionalContent = React.forwardRef(function AdditionalContent({ placement, children, onClick }, ref) {
    if (!children) {
        return null;
    }
    return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    React.createElement("div", { ref: ref, className: b('additional-content', { placement }), onClick: onClick }, children));
});
